import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatTermModel } from 'src/app/model/cat-term.model';

@Injectable({
  providedIn: 'root'
})
export class CatTermService {
  private url: string;

  ////////////////
  constructor(
    private http: HttpClient
  ) {
    this.url = environment.services_url;
  }

  //
  getAll = () => {
    return this.http.get(`${this.url}/CatTerm/list`)
      .pipe(
        map((resp: any) => resp)
      );
  }

  save = (userName: string, term: CatTermModel) => {
    return this.http.post(`${this.url}/CatTerm/saveCatTerm/${userName}`, term)
      .pipe(
        map((resp: any) => resp)
      );
  }

  upload = (userName: string, file: File, replace: boolean) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userName', userName);
    formData.append('table', 'term');
    formData.append('replace', String(replace));
    return this.http.post(`${this.url}/upload/save`, formData)
      .pipe(
        map((resp: any) => resp)
      );
  }

  downloadLayout = () => this.http.get(`${this.url}/CatTerm/DownloadLayout`, { responseType: 'blob' });
}
